/* @flow */
import getWindow from '@loggi/js/get-window';

type OptimizelyExperiment = {
  name: string
};

type OptimizelyDataState = {
  variationNamesMap: { [key: string]: string }
};

type OptimizelyData = {
  experiments: { [key: string]: OptimizelyExperiment },
  state: OptimizelyDataState,
  state: any
};

type Optimizely = {
  data: OptimizelyData,
  activeExperiments: Array<string>
};

export default function getOptimizely(): ?Optimizely {
  const $window = getWindow();
  if ($window !== null) {
    return $window.optimizely || null;
  }
  return null;
}

export function getOptimizelyActiveExperiments() {
  const optimizely: ?Optimizely = getOptimizely();
  if (optimizely && optimizely.activeExperiments) {
    return optimizely.activeExperiments.map(experimentId => {
      const experimentName = optimizely.data.experiments[experimentId].name;
      const variationName =
        optimizely.data.state.variationNamesMap[experimentId];
      return { name: experimentName, variation: variationName };
    });
  }
  return [];
}
